<po-page-edit
  p-title="Pré-cadastro Produto"
  [p-breadcrumb]="breadcrumb"
>
  <form #formPrincipal="ngForm">
    <po-widget class="po-sm-12 po-md-12 po-lg-12"
      p-title="Informações do Produto - Solicitante"
    >
      <po-input class="po-sm-12 po-md-9 po-lg-10"
        name="CB1DESC"
        p-label="Descrição"
        [(ngModel)]="preProduto.CB1DESC"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
        p-maxlength="80"
      ></po-input>
      <po-select class="po-sm-6 po-md-3 po-lg-2"
        name="CB1MRP"
        p-label="Controle de Estoque?"
        [(ngModel)]="preProduto.CB1MRP"
        [p-options]="[
          {value: 'S', label: 'Sim'},
          {value: 'N', label: 'Não'},
        ]"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>
      @if (preProduto.CB1MRP === 'S' ) {
        <po-decimal class="po-sm-4 po-md-3 po-lg-2"
          name="NB1EMIN"
          p-label="Estoque Mínimo"
          [(ngModel)]="preProduto.NB1EMIN"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-decimals-length="0"
          p-clean="true"
        ></po-decimal>
        <po-decimal class="po-sm-4 po-md-3 po-lg-2"
          name="NB1EMAX"
          p-label="Estoque Máximo"
          [(ngModel)]="preProduto.NB1EMAX"
          p-required="true"
          [p-disabled]="bloqueiaDadosSolicitante"
          p-decimals-length="0"
          p-clean="true"
        ></po-decimal>
      }
      <po-select class="po-sm-6 po-md-4 po-lg-3"
        name="CB1UM"
        p-label="Unidade Medida"
        [(ngModel)]="preProduto.CB1UM"
        [p-options]="[
          {value: 'KG', label: 'KG'},
          {value: 'L', label: 'L'},
          {value: 'M3', label: 'M3'},
          {value: 'MT', label: 'MT'},
          {value: 'PC', label: 'PC'},
          {value: 'TN', label: 'TN'},
          {value: 'SE', label: 'SE'},
        ]"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>
      <po-select class="po-sm-6 po-md-4 po-lg-3"
        name="CB1SEGUM"
        p-label="Segunda Unidade Medida"
        [(ngModel)]="preProduto.CB1SEGUM"
        [p-options]="[
          {value: 'KG', label: 'KG'},
          {value: 'L', label: 'L'},
          {value: 'M3', label: 'M3'},
          {value: 'MT', label: 'MT'},
          {value: 'PC', label: 'PC'},
          {value: 'TN', label: 'TN'},
        ]"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-select>
      @if(preProduto.CB1SEGUM){
        <po-decimal class="po-sm-6 po-md-4 po-lg-4"
          name="NB1CONV"
          p-label="Fator de Conversão de UM"
          [(ngModel)]="preProduto.NB1CONV"
          p-maxlength="12"
          p-min="0.00000001"
          p-decimals-length="8"
          p-thousand-maxlength="3"
          [p-disabled]="bloqueiaDadosSolicitante">
        </po-decimal>
      }
      <po-combo class="po-sm-12 po-md-6 po-lg-6"
        name="CB1POSIPI"
        p-label="NCM"
        [(ngModel)]="preProduto.CB1POSIPI"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/ncm"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-clean="true"
      ></po-combo>
      <po-combo class="po-sm-12 po-md-4"
        name="CSETOR"
        p-label="Setor"
        [(ngModel)]="preProduto.CSETOR"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/ctt"
        [p-filter-params]="{combobox:'S', setor:'S'}"
        p-disabled-init-filter="false"
        p-infinite-scroll="true"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
      ></po-combo>
      <po-input class="po-sm-12 po-md-4"
        name="CUSOAPLICACAO"
        p-label="Como será utilizado? (Aplicação)"
        [(ngModel)]="preProduto.CUSOAPLICACAO"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-maxlength="30"
      ></po-input>
      <po-input class="po-sm-12 po-md-4"
        name="CLOCALUSO"
        p-label="Onde será utilizado?"
        [(ngModel)]="preProduto.CLOCALUSO"
        p-required="true"
        [p-disabled]="bloqueiaDadosSolicitante"
        p-maxlength="30"
      ></po-input>
    </po-widget>
    @if ( !bloqueiaDadosCompras || !bloqueiaDadosControladoria ) {
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Informações do Produto - Compras"
      >
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1GRUPO"
          p-label="Grupo"
          [(ngModel)]="preProduto.CB1GRUPO"
          (p-change)="changeGrupo()"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrproduto/grupo"
          [p-filter-params]="{combobox:'S',CBMCLASOL: '5'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosCompras"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1LOCPAD"
          p-label="Local Padrão"
          [(ngModel)]="preProduto.CB1LOCPAD"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrproduto/armazem"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosCompras"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XFAM"
          p-label="Família Estrutural"
          [(ngModel)]="preProduto.CB1XFAM"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrproduto/familia"
          [p-filter-params]="{combobox:'S', CZANCLASOL:'5', CB1GRUPO:preProduto.CB1GRUPO}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosCompras||bloqueiaFamiliaEstrutural"
          p-clean="true"
        ></po-combo>

      </po-widget>
    }
    @if ( !bloqueiaDadosControladoria ) {
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Informações do Produto - Controladoria"
      >
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1TIPO"
          p-label="Tipo"
          [(ngModel)]="preProduto.CB1TIPO"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrbase/sx5/02"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1CONTA"
          p-label="Conta Estoque"
          [(ngModel)]="preProduto.CB1CONTA"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XCTACUS"
          p-label="Conta de Custo"
          [(ngModel)]="preProduto.CB1XCTACUS"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XCTADEA"
          p-label="Conta Despesa Administrativa"
          [(ngModel)]="preProduto.CB1XCTADEA"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XCTADEC"
          p-label="Conta Despesa Comercial"
          [(ngModel)]="preProduto.CB1XCTADEC"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrcontabilidade/contacontabil"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1TE"
          p-label="TE (tipo de entrada padrão)"
          [(ngModel)]="preProduto.CB1TE"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrtes"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-infinite-scroll="true"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
        <po-combo class="po-sm-6 po-md-4 po-lg-4"
          name="CB1XTPSPED"
          p-label="Tipo SPED"
          [(ngModel)]="preProduto.CB1XTPSPED"
          p-icon="po-icon-search"
          p-field-label="label"
          p-field-value="value"
          p-filter-service="{{urlApiProtheus}}/wsrbase/sx5/ZS"
          [p-filter-params]="{combobox:'S'}"
          p-disabled-init-filter="false"
          p-required="true"
          [p-disabled]="bloqueiaDadosControladoria"
          p-clean="true"
        ></po-combo>
      </po-widget>
    }
    @if (liberaAvancarProcesso){
      <po-widget class="po-sm-12 po-md-12 po-lg-12"
        p-title="Outras informações técnicas importantes"
      >
        <po-textarea class="po-sm-12 po-md-12 po-lg-12"
          name="OBSERVACAO"
          [(ngModel)]="historico"
          p-rows="4"
          p-required="true"
          p-minlength="10"
        ></po-textarea>
        <po-button class="po-sm-6 po-md-6 po-lg-6"
          p-label="{{ [' ','2'].includes(processoCadastro.CSTATUS) ? 'Cancelar' : 'Recusar' }} Processo"
          p-danger="true"
          (p-click)="cancelarRecusarTela()"
        ></po-button>
        <po-button class="po-sm-6 po-md-6 po-lg-6"
          p-label="Avançar Processo"
          (p-click)="confirmarTela()"
        ></po-button>
      </po-widget>
    }
  </form>
  <po-divider class="po-row" p-label="Anexos"></po-divider>
  <po-button class="po-sm-12 po-md-12 po-lg-12"
    p-label="Imagens"
    p-icon="po-icon-picture"
    (p-click)="arquivosLoadDados()"
  ></po-button>
  <po-divider class="po-row" p-label="Histórico do Processo"></po-divider>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-items]="tabelaHistorico"
    [p-columns]="tabelaHistoricoColunas"
    p-container="true"
    p-spacing="small"
  ></po-table>
</po-page-edit>

<po-page-slide #anexoPageSlide
  p-title="Anexos"
  p-size="xl"
  p-click-out="true">
  <app-util-arquivo #utilArquivo [podeExcluir]="false" [habilitaUpload]="bloqueiaDadosControladoria"></app-util-arquivo>
</po-page-slide>
